import ReactGA from 'react-ga4';
import { VITE_GA_MEASUREMENT_ID } from '../envs';

try {
    ReactGA.initialize(VITE_GA_MEASUREMENT_ID, {});
} catch {
    console.error('Failed to initialize GA');
}

